import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import Footer from '../components/Footer';
import styles from '../styles/NavButton.module.css';
import homeStyles from '../styles/Home.module.css';

const Home = () => {
  const { isDarkMode } = useTheme();
  const { isAuthenticated, student, school } = useAuth();

  // Debug logging
  console.log('Auth state in Home:', {
    isAuthenticated,
    hasStudent: !!student,
    hasSchool: !!school,
    studentName: student?.name,
    schoolName: school?.name
  });

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 6 && hour < 12) return 'Buenos días,';
    if (hour >= 12 && hour < 20) return 'Buenas tardes,';
    return 'Buenas noches,';
  };

  return (
    <>
      <div className={homeStyles.titleContainer}>
        <h1 className={homeStyles.greeting}>
          {getGreeting()}{isAuthenticated ? ` ${student?.name || school?.name || ''}` : ''}
        </h1>
        <h2 className={homeStyles.questionTitle}>
          ¿Qué quieres practicar hoy?
        </h2>
      </div>

      <div className="container">
        <div className={homeStyles.homeContainer}>
          <nav style={{
            marginBottom: '1rem'
          }}>
            <ul style={{
              listStyle: 'none',
              padding: '0',
              display: 'grid',
              gap: '1rem'
            }}>
              <li>
                <Link
                  to="/mercancias"
                  className={`${styles.navButton} ${styles.testCompleto} ${isDarkMode ? styles.dark : ''}`}
                >
                  <h3 className={styles.title} style={{ color: '#000080' }}>CAP Mercancías</h3>
                  <p className={styles.description} style={{ color: '#000080' }}>
                    Prepárate para el examen de transporte de mercancías
                  </p>
                </Link>
              </li>
              <li>
                <Link
                  to="/viajeros"
                  className={`${styles.navButton} ${styles.modoPractica} ${isDarkMode ? styles.dark : ''}`}
                >
                  <h3 className={styles.title} style={{ color: '#000080' }}>CAP Viajeros</h3>
                  <p className={styles.description} style={{ color: '#000080' }}>
                    Prepárate para el examen de transporte de viajeros
                  </p>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;